module.exports = __webpack_public_path__ + "static/man-raising-hand-203c88292bf71558c0d3ce7f9ed42822.png";